import { useRef } from 'react'

import issueStyles from '../../components/issues/issue.module.scss'
import { domains } from '../../utils/index.js'

import styles from './domain.module.scss'

export function Domain ({ domain, lists = [] }) {
  const domainRef = useRef(null)
  const listDomain = lists?.domain?.find(d => d.id === domain) || null

  // useEffect(() => {
  //   if (!listDomain && domainRef?.current) {
  //     domainRef.current.childNodes[0].innerHTML =
  //       "<span style='text-transform: lowercase !important;'>i</span>"
  //   }
  // }, [ domainRef, listDomain ])

  return (
    <div className={issueStyles.domain}>
      {domain
        ? (
          <div className={styles.tooltipContainer}>
            <div
              ref={domainRef}
              title={`${listDomain?.name} ${listDomain?.type ? '\n' + listDomain?.type : ''} `}
            >
              {domains[domain] || ''}
            </div>
          </div>
        )
        : null}
    </div>
  )
}
